import { useEffect, useState } from 'react';
import { idValueToOptions } from '../../libs/selectTools';
import { JiraFromUI } from '@app/booking-frontend-libs';
export function useFieldOptions(config) {
    const [options, setOptions] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    const [isLoadingFields, setIsLoadingFields] = useState(true);
    useEffect(() => {
        if (config) {
            const { resourceFieldId, projectId, issuetypeId } = config;
            JiraFromUI.getFieldOptions(resourceFieldId, projectId, issuetypeId).then((values) => {
                setOptions(values);
                setSelectOptions(idValueToOptions(values));
                setIsLoadingFields(false);
            });
        }
    }, [config]);
    return { options, selectOptions, isLoadingFields };
}
